import React from "react";
import { MapContainer, TileLayer, Marker } from "react-leaflet";

import AboutInfo from "./AboutInfo/AboutInfo";

import cl from "./About.module.css";

const About = (props) => {
  const position = props.aboutData.coordinates?.split(", ") || [
    40.808712, -73.946818,
  ];

  return (
    <section className={cl.app_about}>
      <AboutInfo
        shopStory={props.aboutData.story}
        shopMessage={props.aboutData.message}
      />
      {/* <p shopMessage={props.aboutData.message} /> */}
    </section>
  );
};

export default About;
